import Person1Img from './images/unnamed.png';
import Person2Img from './images/unnamed (1).png';
import Person3Img from './images/reviews3-joao.png';
import Person4Img from './images/reviews4-evandro.png';

const reviews = [
    {
        id: 1,
        description: 'Bons serviços e boa comida.',
        img: [Person1Img],
        name: 'Petar Milohanovic',
        initialMotion: '-300px'
    },
    {
        id: 2,
        description: 'Fomos comer Sushi e estava muito bom. O serviço é simpático e atencioso e a comida não demora muito.',
        img: [Person2Img],
        name: 'Pfluger Barreto',
        initialMotion: '350px'
    },
    {
        id: 3,
        description: 'Very good service, good menu … not overly extensive. Food was very good quality all around. They know how to prepare home fries and their sushi and Espetada are top-notch. Prices were reasonable.',
        img: [Person3Img],
        name: 'Joao Mutindi',
        initialMotion: '-300px'
    },
    {
        id: 4,
        description: 'Não consegui contacto com o restaurante, diz que o número não está disponível',
        img: [Person4Img],
        name: 'Evandro Teixeira',
        initialMotion: '350px'
    }
];

export default reviews;